<template>
    <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
        <div style="padding:0px;width:100%;">
            <div class="whiteBox dashboard_topic">
                <div class="portlet-title">
                    <i class="el-icon-d-arrow-right">&nbsp;</i>三大垂媒线索到店率
                </div>
                <div class="portlet-content">
                    <div class="filter-container" style="padding-top: 0px; height: 28px;">
                        <el-radio-group class="filter-item" size="mini" v-model="listQuery.dateType" @change="listQuery.searchDate = new Date();">
                            <el-radio-button :label="3">按月</el-radio-button>
                            <el-radio-button :label="4">按年</el-radio-button>
                        </el-radio-group>
                        <el-date-picker key="month" :picker-options="datePickerOption" style="height: 28px;" class="filter-item" size="mini" v-if="listQuery.dateType == 3" :clearable="false" v-model="listQuery.searchDate" type="month" format="yyyy年MM月" placeholder="选择月">
                        </el-date-picker>
                        <el-date-picker key="year" :picker-options="datePickerOption" style="height: 28px;" class="filter-item" size="mini" v-if="listQuery.dateType == 4" :clearable="false" v-model="listQuery.searchDate" type="year" format="yyyy年" placeholder="选择年">
                        </el-date-picker>
                        <el-button class="filter-item" size="mini" type="info" icon="el-icon-search" @click="doSearch">查看</el-button>
                        <el-button class="filter-item" size="mini" icon="el-icon-refresh" @click="doReset">重置</el-button>
                        <el-button class="filter-item" size="mini" icon="el-icon-download" @click="doExport">导出</el-button>
                    </div>

                    <el-table :data="list" stripe  id="table" v-loading="listLoading">
                        <el-table-column prop="month" label="时间（月）">
                        </el-table-column>
                        <el-table-column prop="clueCount" label="三大垂媒线索总数" width="150">
                            <template slot="header" slot-scope="scope">
                                三大垂媒线索总数
                                <el-popover placement="top-start" width="200" trigger="hover" :content="tips.tip3">
                                    <i class="fa fa-question-circle-o" aria-hidden="true" slot="reference" ></i>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="validCount" label="三大垂媒有效线索数" width="160">
                            <template slot="header" slot-scope="scope">
                                三大垂媒有效线索数
                                <el-popover placement="top-start" width="200" trigger="hover" :content="tips.tip4" >
                                    <i class="fa fa-question-circle-o" aria-hidden="true" slot="reference" ></i>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="validArrivalCount" label="三大垂媒有效线索到店数">
                        </el-table-column>
                        <el-table-column prop="arrivalRate" label="三大垂媒有效线索到店率" width="170">
                            <template slot="header" slot-scope="scope">
                                三大垂媒有效线索到店率
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover"
                                    :content="tips.tip1"
                                >
                                    <i
                                        class="fa fa-question-circle-o"
                                        aria-hidden="true"
                                        slot="reference"
                                    ></i>
                                </el-popover>
                            </template>
                            <template slot-scope="scope">
                                <span>{{ scope.row.arrivalRate ? `${scope.row.arrivalRate}%` : 0 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="clueArrivalRate" label="三大垂媒线索到店率">
                            <template slot="header" slot-scope="scope">
                                三大垂媒线索到店率
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover"
                                    :content="tips.tip2"
                                >
                                    <i
                                        class="fa fa-question-circle-o"
                                        aria-hidden="true"
                                        slot="reference"
                                    ></i>
                                </el-popover>
                            </template>
                            <template slot-scope="scope">
                                <span>{{ scope.row.clueArrivalRate ? `${scope.row.clueArrivalRate}%` : 0 }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
    data() {
        return {
            dayjs: dayjs,
            dealer: this.$common.getDealer(),
            list: null,
            listLoading: false,
            listQuery: {
                dateType: 3,
                searchDate: new Date(),
                dateRange: [new Date(), new Date()],
            },
            datePickerOption: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return time.getTime() < new Date('2026-01-01').getTime();
                },
            },
            tips: {
                tip1: '仅统计每月（当月截止T-1天）由汽车之家、易车、懂车帝三大垂媒平台的有效线索到店率，到店数以客流统计到店数为准',
                tip2: '仅统计每月（当月截止T-1天）由汽车之家、易车、懂车帝三大垂媒平台的线索到店率，到店数已客流统计到店数为准',
                tip3: '当月新下发的垂媒新线索（剔除下发异常、等待下发及重复未下发线索）',
                tip4: '当月垂媒线上新建档的线索'
            }
        };
    },
    mounted() {
        this.doSearch();
    },
    methods: {
        doSearch() {
            this.listLoading = true;
            this.$httpAuth
                .post("/v2/v2DealerReportRpc/arrivalRateSummary", this.getParams())
                .then((response) => {
                    const data = response.data;
                    this.list = data.data || [];
                    this.listLoading = false;
                }).catch(() => {
                    this.listLoading = false;
                });
        },
        doReset() {
            this.list = null;
            this.listLoading = false;
            this.listQuery = {
                dateType: 3,
                searchDate: new Date(),
                dateRange: [new Date(), new Date()],
                page: 1,
                limit: 10,
            };
            this.doSearch();
        },
        doExport() {
            const loading = this.$loading({
                lock: true,
                text: '正在导出中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$httpAuth
                .post("/v2/v2DealerReportRpc/arrivalRateSummary", {...this.getParams(), isExport: true})
                .then((response) => {
                    const { file, total } = response.data
                    if (total > 2000) {
                        this.$message({
                            customClass: 'export-message',
                            dangerouslyUseHTMLString: true,
                            message: '<div>应安全要求，一次性最多只能导出2000条数据</div>',
                            duration: 2000
                        });
                    }
                    setTimeout(() => {
                        loading.close()
                        let a = document.createElement('a');
                        a.href = file;
                        a.click();
                    }, 1000);
                })
                .catch(() => {
                    loading.close()
                });
        },
        getParams() {
            let startDate = '';
            let endDate = ''
            if (this.listQuery.dateType == 3) {
                startDate = this.$common.getFirstDayOfMonth(this.listQuery.searchDate);
                endDate = this.$common.getEndDayOfMonth(this.listQuery.searchDate);
            }
            if (this.listQuery.dateType == 4) {
                startDate = this.$common.getFirstDayOfYear(this.listQuery.searchDate);
                endDate = this.$common.getEndDayOfYear(this.listQuery.searchDate);
            }
            const targetDate = dayjs(endDate)
            const currentDate = dayjs().format('YYYY-MM-DD')
            const isGreaterOrEqualAlt  = !targetDate.isBefore(currentDate)
            return {
                dealerId: this.dealer.dealerId,
                startDate: startDate,
                endDate: isGreaterOrEqualAlt ? (dayjs().subtract(1, 'day').format('YYYY-MM-DD')) : endDate,
            }
        }
    }
}
</script>

<style>

</style>
